"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What is the resident capacity at Family First Senior Care?",
  answer: "We maintain a small, intimate environment in Silver Spring, MD, with a maximum capacity of just 5 residents. This limited capacity allows us to provide highly personalized care, dedicated attention, and a true family-like atmosphere where every senior is treated with the utmost respect."
}, {
  question: "Are the rooms private or shared?",
  answer: "At our Silver Spring home, all residents enjoy their own private rooms. We believe privacy and dignity are paramount, so each room is comfortably furnished to feel just like home, providing a personal sanctuary within our small community."
}, {
  question: "What kind of meals are provided?",
  answer: "We serve nutritious, home-cooked meals daily in our family dining area. Because we only care for up to 5 residents, we can easily tailor our menus to meet the specific dietary needs, health restrictions, and personal preferences of each individual."
}, {
  question: "Is there 24/7 staff available?",
  answer: "Yes, our Silver Spring residence is staffed by compassionate caregivers 24 hours a day, 7 days a week. With a maximum of 5 residents, our high staff-to-resident ratio ensures that personalized support and immediate assistance are always available."
}, {
  question: "How can we schedule a visit to see the home?",
  answer: "We would love to welcome you for a tour of our warm, family-like environment in Silver Spring. You can easily schedule a visit by calling us directly at (301) 555-1234, or by using the request form on our Schedule a Tour page."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="common-questions" className="bg-background py-16 md:py-24 lg:py-32">
      <div ref={ref} className={`container mx-auto max-w-3xl px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mb-12 text-center md:mb-16">
          <h2 className="text-primary mb-4 font-serif text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
            Frequently Asked Questions about Our Small Residential Assisted Living Home
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl font-sans text-lg leading-relaxed">
            Find answers to common questions about our intimate community in Silver Spring, Maryland. We specialize in providing personalized care for up to 5 residents in a warm, family-like atmosphere.
          </p>
        </div>

        <div className="bg-card rounded-2xl border p-6 shadow-sm md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
                <AccordionTrigger className="text-primary hover:text-primary/80 text-left font-sans text-base font-bold hover:no-underline md:text-lg">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-sans text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center md:mt-16">
          <p className="text-muted-foreground mb-6 font-sans text-lg">
            Still have questions or need more specific information?
          </p>
          <Button asChild size="lg" className="rounded-full px-8">
            <Link to="/ContactPage">Contact Us for Personalized Care</Link>
          </Button>
        </div>
      </div>
    </section>;
}